/** @typedef {import('./CopyToClipboardProps').default} Props */

import { translate } from '../../App/Internationalization';
import BaseButton from '../BaseButton/BaseButton';
import captureError from '../../utils/captureError';
import images from '../../config/local/images';
import React from 'react';

/** @extends {React.Component<Props>} */
export default class CopyToClipboard extends React.Component {
	/**
	 * @param {string} text
	 * @returns {void}
	 */
	static #copyWithoutClipboardApi(text) {
		const textArea = document.createElement('textarea');
		textArea.value = text;
		textArea.style.position = 'fixed';
		textArea.style.opacity = '0';
		document.body.appendChild(textArea);

		try {
			textArea.focus();
			textArea.select();

			if (!document.execCommand('copy')) {
				throw new Error('Unable to copy text to the clipboard.');
			}
		} finally {
			document.body.removeChild(textArea);
		}
	}

	/**
	 * @param {Props} props
	 */
	constructor(props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}

	/**
	 * @returns {Promise<void>}
	 */
	async handleClick() {
		if (!this.props.url) {
			return;
		}

		try {
			if (window.navigator.clipboard) {
				try {
					await window.navigator.clipboard.writeText(this.props.url);
				} catch {
					CopyToClipboard.#copyWithoutClipboardApi(this.props.url);
				}
			} else {
				CopyToClipboard.#copyWithoutClipboardApi(this.props.url);
			}

			if (this.props.onSuccess) {
				this.props.onSuccess();
			}
		} catch (error) {
			captureError(error);
		}
	}

	/**
	 * @returns {JSX.Element}
	 */
	render() {
		return (
			<BaseButton
				className={this.props.className}
				icon={images.icons.link}
				onClick={this.handleClick}
				outline={true}
			>
				{this.props.text}
			</BaseButton>
		);
	}
}

CopyToClipboard.defaultProps = {
	text: translate('global.links.copy'),
};
